<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <h1 class="titulo-pagina">{{ 'ALFRESCO.LBL_ALFRESCO' | translate}}</h1>
  </div>
</div>
<p-panel>
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <div class="grid">
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <label> {{ 'ALFRESCO.LBL_ORIGEN' | translate }}</label>
            <label class="falso-combo-texto">{{alfresco.urlOrigen}}</label>
          </div>
        </div>
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <label> {{ 'ALFRESCO.LBL_DESTINO' | translate }}</label>
            <label class="falso-combo-texto">{{alfresco.urlDestino}}</label>
          </div>
        </div>
      </div>
      <div class="grid" *ngIf="submitted">
        <div class="col-12 md:col-12">
          <p-progressBar [value]="archivo.porcentaje"></p-progressBar>
        </div>
        <div class="col-12 md:col-7 ">
          <label *ngIf="error " class="text-center texto-rojo pull-right">{{ 'ALFRESCO.MSG_ERROR'  | translate}}</label>
        </div>
        <div class="col-5">
          <label class="pull-right"> {{archivo.transferidos}}/{{archivo.total}}</label>
        </div>

      </div>
      <div class="grid form-footer-buttons" >
        <div class="form-group col-12">
          <div >
            <a (click)="cancelar()" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
            <button *ngIf="!submitted" icon="fa fa-angle-double-right" label="{{'ALFRESCO.BTN_TRANSFERIR' | translate }}"
                    (click)="confirmar()"
                    pButton></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-panel>
<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
